import { render } from "./InstaUnfolowerPage.vue?vue&type=template&id=30af1254&ts=true"
import script from "./InstaUnfolowerPage.vue?vue&type=script&lang=ts"
export * from "./InstaUnfolowerPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__